import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=a3f233b6&scoped=true&"
import script from "./regions.vue?vue&type=script&lang=js&"
export * from "./regions.vue?vue&type=script&lang=js&"
import style0 from "./regions.vue?vue&type=style&index=0&id=a3f233b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f233b6",
  null
  
)

export default component.exports